import { isEdge, isIE11, isFirefox } from './';

export function launchApp(url: string) {
    if (isEdge() || isIE11() || isFirefox()) {
        window.open(url);

        setTimeout(() => {
            window.close();
        }, 1000);
    } else {
        window.location.href = url;
    }
}

export function launchAuthAnvilApp(tokenSecret: string) {
    const url = tokenSecret.replace('otpauth://', 'authanvil-push://');
    launchApp(url);
}

export function launchYubikeyApp(tokenSecret: string) {
    const url = tokenSecret.replace('otpauth://', 'passly-hotp://');
    launchApp(url);
}
